import { useBlogEnabled } from '@/shared/hooks/useBlogEnabled'
import { useColonyEnabled } from '@/shared/hooks/useColonyEnabled'
import { useGroupTripEnabled } from '@/shared/hooks/useGroupTripEnabled'
import { useListingEnabled } from '@/shared/hooks/useListingEnabled'
import { useLotteryEnabled } from '@/shared/hooks/useLotteryEnabled'
import { useMatchEventEnabled } from '@/shared/hooks/useMatchEventEnabled'
import { usePartnerOfferEnabled } from '@/shared/hooks/usePartnerOfferEnabled'
import type { OptionalModuleFlags } from '@/shared/lib/optionalModuleNav'

/** Feature-flag snapshot for optional portal nav links (chrome, ⌘K, MeLayout). */
export function useOptionalModuleNavFlags(): OptionalModuleFlags {
  return {
    lottery: useLotteryEnabled(),
    match_event: useMatchEventEnabled(),
    group_trip: useGroupTripEnabled(),
    listing: useListingEnabled(),
    blog: useBlogEnabled(),
    partner_offer: usePartnerOfferEnabled(),
    colony: useColonyEnabled(),
  }
}
